import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { CdcLojaService } from '../../../../services/cdc-loja.service';
export class ModalValidandoComponent {
    constructor(bsModalRef, service) {
        this.bsModalRef = bsModalRef;
        this.service = service;
        this.confirmValue = new EventEmitter();
        this.onValidar = new EventEmitter();
        this.titulo = '';
        this.mensagem = 'Mensagem';
        this.labelFechar = 'Ok, entendi';
        this.showFecharBtn = true;
        this.showOkBtn = true;
        this.isTituloVermelho = false;
        this.alive = true;
    }
    ngOnInit() {
        this.cadastrarBiometriaUnico();
    }
    ngOnDestroy() {
        this.alive = false;
    }
    showModal(options) {
        if (options) {
            this.titulo = options.titulo || this.titulo;
            this.mensagem = options.mensagem || this.mensagem;
            this.labelFechar = options.labelFechar || this.labelFechar;
            this.showFecharBtn = options.showFecharBtn || this.showFecharBtn;
            this.showOkBtn = options.showOkBtn || this.showOkBtn;
            this.isTituloVermelho = options.isTituloVermelho || this.isTituloVermelho;
        }
    }
    onClickClose() {
        this.confirmValue.emit(false);
        this.bsModalRef.hide();
    }
    cadastrarBiometriaUnico() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const request = {
                imgBase64: this.foto
            };
            const propostaId = this.proposta;
            try {
                const assessment = yield this.service
                    .enviarBiometriaUnico(propostaId, request)
                    .toPromise();
                this.onValidar.emit(assessment);
            }
            catch (error) {
                console.error(error);
                this.onValidar.emit(null);
            }
            this.bsModalRef.hide();
        });
    }
}
